import axios from 'axios';

import { assertClientSide } from '@dr.pogodin/react-utils';

import { P_API_BLOG, getConfig } from 'utils';

export async function deleteBlogItem(id: string): Promise<void> {
  assertClientSide();

  const config = await getConfig();

  await axios.delete(`${P_API_BLOG}/${id}`, {
    headers: {
      'csrf-token': config.CSRF,
    },
  });
}
